import { render } from "./s-link.vue?vue&type=template&id=56932ccb"
import script from "./s-link.vue?vue&type=script&lang=js"
export * from "./s-link.vue?vue&type=script&lang=js"

import exportComponent from "D:\\projects\\paintcare\\pcsitelocator\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__